var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white",
    fillOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13593_15982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 12.7275L17.737 12.2498L15 5.37402L12.263 12.2498L5 12.7275L10.5726 17.4513L8.74438 24.6263L15 20.6726L21.2556 24.6263L19.4275 17.4516L25 12.7275ZM15 19.2862L10.6069 22.0628L11.8892 17.0304L7.96207 13.7067L13.0781 13.3707L15 8.54262L16.9219 13.3707L22.0439 13.7067L18.1107 17.03L19.3931 22.0628L15 19.2862Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13593_15982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderedStar);
export default __webpack_public_path__ + "static/media/bordered_star.52b4e8131d498a7f4a43ff68dc98bd02.svg";
export { ForwardRef as ReactComponent };